// 🔹 React Core
import React, { useState } from "react";

// 🔹 UI Component Libraries
import { Modal } from "antd";

// 🔹 State Management
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";

// 🔹 Internal Components
import { BtnLoader } from "../../../../../Components/Components";
import { SummaryHtmlEditor } from "../../../../../Components/ckeditor";

// 🔹 Redux Actions
import { UpdateCategorySummaryAPI } from "../../../../Redux/summaryDetails";

// 🔹 Assets
import { svg } from "../../../../../Assets/svg";

const EditSummaryDetailsModal: React.FC<{
  setState: React.Dispatch<React.SetStateAction<boolean>>;
  options: any; // { key, value, title, input_title }
  onSuccess: () => void;
}> = ({ setState, options, onSuccess }) => {
  // Descruture
  const { open } = options || {};

  // Use
  const dispatch = useAppDispatch();

  // Selector
  const { updateCategorySummaryLoading } = useAppSelector(
    (state: RootState) => state?.loading,
  );

  // Defalut
  const TYPE_VALUES: Record<string, string> = {
    ui: "quoteData",
    pdf: "pdfData",
  };
  const TYPE_LABELS: Record<string, string> = {
    ui: "Paragraph Quotation UI",
    pdf: "Paragraph Quotation PDF",
  };
  const typeValue = TYPE_VALUES[options?.type];
  const type = TYPE_LABELS[options?.type];
  const reverseType = options?.type === "ui" ? "pdfData" : "quoteData";

  // Data
  const [summaryData, setSummaryData] = useState(
    options?.data?.[typeValue] || "",
  );

  // Handler
  const onClose = () => {
    setState(false);
  };

  const handleSave = () => {
    const payload = {
      categorySummaryId: options?.data?._id,
      categoryId: options?.data?.category?._id,
      updates: {
        [typeValue]: summaryData,
      },
    };

    dispatch(
      UpdateCategorySummaryAPI(payload, () => {
        onSuccess();
      }),
    );
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Update {type} for {options?.data?.name || options?.data?.category?.name}
        </div>
      }
      open={open}
      onCancel={onClose}
      width={"65rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130 text-uppercase"
            onClick={onClose}
            disabled={updateCategorySummaryLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="submitEditVariable"
            disabled={updateCategorySummaryLoading}
            className={`btn btn-lg min-w-130 btn-primary text-uppercase`}
            onClick={handleSave}
          >
            {updateCategorySummaryLoading ? <BtnLoader /> : "Update"}
          </button>
        </div>
      }
      className="custom-modal"
    >
      <div className="page-form">
        <div className="mb-0">
          <label className="fw-semibold fs-5">{type}</label>
          <div className="quill-editor-container rounded-2 overflow-hidden border">
            <SummaryHtmlEditor
              initialData={summaryData}
              onChange={(data: any) => setSummaryData(data)}
              placeholder={`Enter ${type} here`}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditSummaryDetailsModal;
